import React from "react";
import ReactDOM from "react-dom";
import loadable from '@loadable/component';

export function load() {
  const App = loadable(() => import('./app'));
  ReactDOM.render(<App />, document.querySelector("#ov_app_aov_progress_bar"));
}
